/* eslint-disable max-lines */
import { useEffect } from 'react';

type LoadingType = {
  componentLoading?: boolean;
};

const KEYFRAMES = `
  @keyframes ld-cw  { to { transform: rotate(360deg);  } }
  @keyframes ld-ccw { to { transform: rotate(-360deg); } }
  @keyframes ld-float {
    0%,100% { transform: translateY(0px);  }
    50%     { transform: translateY(-3px); }
  }
  @keyframes ld-progress {
    0%   { width: 0%;   opacity: 1; }
    65%  { width: 100%; opacity: 1; }
    100% { width: 100%; opacity: 0; }
  }
  @keyframes ld-check-draw {
    0%   { stroke-dashoffset: 30; opacity: 0.15; }
    45%  { stroke-dashoffset: 0;  opacity: 1;    }
    80%  { stroke-dashoffset: 0;  opacity: 1;    }
    100% { stroke-dashoffset: 30; opacity: 0.15; }
  }
  @keyframes ld-circle-scale {
    0%,100% { transform: scale(1);    opacity: 1;   }
    45%     { transform: scale(1.12); opacity: 0.9; }
    80%     { transform: scale(1);    opacity: 1;   }
  }
`;

/* 4 brand colors cycling across 7 icons */
const C1 = '#120A8F'; // navy
const C2 = '#38C63A'; // green
const C3 = '#FFB800'; // yellow
const C4 = '#E53935'; // red
const PALETTE = [C1, C2, C3, C4, C1, C2, C3];

const ICONS = [
  /* Rule */
  <svg key="rule" viewBox="0 0 18 18" fill="none" width={12} height={12}>
    <rect
      x="2"
      y="7"
      width="14"
      height="4"
      rx="1"
      stroke="white"
      strokeWidth="1.8"
    />
    <line
      x1="5"
      y1="7"
      x2="5"
      y2="5"
      stroke="white"
      strokeWidth="1.4"
      strokeLinecap="round"
    />
    <line
      x1="9"
      y1="7"
      x2="9"
      y2="4.5"
      stroke="white"
      strokeWidth="1.4"
      strokeLinecap="round"
    />
    <line
      x1="13"
      y1="7"
      x2="13"
      y2="5"
      stroke="white"
      strokeWidth="1.4"
      strokeLinecap="round"
    />
  </svg>,
  /* Workflow */
  <svg key="wf" viewBox="0 0 18 18" fill="none" width={12} height={12}>
    <circle cx="3.5" cy="9" r="2" stroke="white" strokeWidth="1.7" />
    <circle cx="14.5" cy="4" r="2" stroke="white" strokeWidth="1.7" />
    <circle cx="14.5" cy="14" r="2" stroke="white" strokeWidth="1.7" />
    <line
      x1="5.4"
      y1="8.3"
      x2="12.5"
      y2="4.6"
      stroke="white"
      strokeWidth="1.3"
      strokeLinecap="round"
    />
    <line
      x1="5.4"
      y1="9.7"
      x2="12.5"
      y2="13.4"
      stroke="white"
      strokeWidth="1.3"
      strokeLinecap="round"
    />
  </svg>,
  /* Calendar */
  <svg key="cal" viewBox="0 0 18 18" fill="none" width={12} height={12}>
    <rect
      x="2.5"
      y="4"
      width="13"
      height="11"
      rx="1.5"
      stroke="white"
      strokeWidth="1.7"
    />
    <line x1="2.5" y1="8" x2="15.5" y2="8" stroke="white" strokeWidth="1.3" />
    <line
      x1="6"
      y1="2"
      x2="6"
      y2="6"
      stroke="white"
      strokeWidth="1.7"
      strokeLinecap="round"
    />
    <line
      x1="12"
      y1="2"
      x2="12"
      y2="6"
      stroke="white"
      strokeWidth="1.7"
      strokeLinecap="round"
    />
    <circle cx="6" cy="11.5" r="1" fill="white" />
    <circle cx="9" cy="11.5" r="1" fill="white" />
    <circle cx="12" cy="11.5" r="1" fill="white" />
  </svg>,
  /* Integration */
  <svg key="int" viewBox="0 0 18 18" fill="none" width={12} height={12}>
    <line
      x1="9"
      y1="13.5"
      x2="9"
      y2="16"
      stroke="white"
      strokeWidth="1.8"
      strokeLinecap="round"
    />
    <line
      x1="6"
      y1="8.5"
      x2="6"
      y2="5"
      stroke="white"
      strokeWidth="1.8"
      strokeLinecap="round"
    />
    <line
      x1="12"
      y1="8.5"
      x2="12"
      y2="5"
      stroke="white"
      strokeWidth="1.8"
      strokeLinecap="round"
    />
    <path
      d="M5 8.5h8v2.5a4 4 0 01-8 0V8.5z"
      stroke="white"
      strokeWidth="1.6"
      strokeLinejoin="round"
    />
  </svg>,
  /* Money */
  <svg key="money" viewBox="0 0 18 18" fill="none" width={12} height={12}>
    <circle cx="9" cy="9" r="6.5" stroke="white" strokeWidth="1.7" />
    <path
      d="M9 5.5v1m0 5v1M7 8.8c0-.8.9-1.3 2-1.3s2 .5 2 1.3S10 10.2 9 10.2 7 10.7 7 11.5s.9 1.3 2 1.3 2-.5 2-1.3"
      stroke="white"
      strokeWidth="1.3"
      strokeLinecap="round"
    />
  </svg>,
  /* Shield */
  <svg key="shield" viewBox="0 0 18 18" fill="none" width={12} height={12}>
    <path
      d="M9 2L3 5v4c0 3.3 2.5 6.1 6 6.9 3.5-.8 6-3.6 6-6.9V5L9 2z"
      stroke="white"
      strokeWidth="1.7"
      strokeLinejoin="round"
    />
    <path
      d="M6.5 9l2 2 3-3"
      stroke="white"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>,
  /* Analytics */
  <svg key="analytics" viewBox="0 0 18 18" fill="none" width={12} height={12}>
    <rect x="2" y="10.5" width="3.5" height="5" rx="0.8" fill="white" />
    <rect x="7" y="7" width="3.5" height="8.5" rx="0.8" fill="white" />
    <rect x="12" y="3" width="3.5" height="12.5" rx="0.8" fill="white" />
  </svg>,
];

/* Orbit positions: r=90px, node 28px (half=14) */
const R = 60;
const HALF = 11;
const NODES = ICONS.map((svg, i) => {
  const deg = -90 + (360 / ICONS.length) * i;
  const rad = (deg * Math.PI) / 180;
  return {
    svg,
    tx: Math.round(R * Math.cos(rad)) - HALF,
    ty: Math.round(R * Math.sin(rad)) - HALF,
    bg: PALETTE[i],
  };
});

const Ring = ({
  size,
  border,
  anim,
}: {
  size: number;
  border: string;
  anim: string;
}) => (
  <div
    style={{
      position: 'absolute',
      top: '50%',
      left: '50%',
      width: size,
      height: size,
      marginTop: -(size / 2),
      marginLeft: -(size / 2),
      borderRadius: '50%',
      border,
      animation: anim,
      pointerEvents: 'none',
    }}
  />
);

const Loading = ({ componentLoading }: LoadingType) => {
  useEffect(() => {
    const id = 'ld-kf';
    if (!document.getElementById(id)) {
      const s = document.createElement('style');
      s.id = id;
      s.textContent = KEYFRAMES;
      document.head.appendChild(s);
    }
  }, []);

  return (
    <div
      className={`flex items-center justify-center ${componentLoading ? 'h-full' : 'h-screen'}`}
    >
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: 12,
        }}
      >
        {/* Orbit area */}
        <div style={{ position: 'relative', width: 160, height: 160 }}>
          {/* Outer ring — green tint */}
          <Ring
            size={140}
            border="1.5px solid rgba(56,198,58,0.4)"
            anim="ld-cw 5s linear infinite"
          />
          {/* Inner ring — red tint */}
          <Ring
            size={100}
            border="1px dashed rgba(18,10,143,0.5)"
            anim="ld-ccw 3.5s linear infinite"
          />

          {/* Glowing dot riding outer ring */}
          <div
            style={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              width: 0,
              height: 0,
              animation: 'ld-cw 5s linear infinite',
            }}
          >
            <div
              style={{
                position: 'absolute',
                width: 7,
                height: 7,
                background: C2,
                borderRadius: '50%',
                transform: `translate(-3.5px, -73.5px)`,
                boxShadow: `0 0 6px ${C2}, 0 0 12px ${C2}`,
              }}
            />
          </div>

          {/* Glowing dot riding inner ring */}
          <div
            style={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              width: 0,
              height: 0,
              animation: 'ld-ccw 3.5s linear infinite',
            }}
          >
            <div
              style={{
                position: 'absolute',
                width: 5,
                height: 5,
                background: C1,
                borderRadius: '50%',
                transform: `translate(-2.5px, 52.5px)`,
                boxShadow: `0 0 5px ${C1}, 0 0 10px ${C1}`,
              }}
            />
          </div>

          {/* Orbit spinner */}
          <div
            style={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              width: 0,
              height: 0,
              animation: 'ld-cw 5s linear infinite',
            }}
          >
            {NODES.map((n, i) => (
              <div
                key={i}
                style={{
                  position: 'absolute',
                  width: 22,
                  height: 22,
                  borderRadius: 6,
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  background: n.bg,
                  boxShadow: `0 0 8px ${n.bg}99`,
                  transform: `translate(${n.tx}px, ${n.ty}px)`,
                  animation: 'ld-ccw 5s linear infinite',
                }}
              >
                {n.svg}
              </div>
            ))}
          </div>

          {/* Phone — centered */}
          <div
            style={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              width: 52,
              height: 52,
              marginTop: -26,
              marginLeft: -26,
              animation: 'ld-float 2s ease-in-out infinite',
              filter: `drop-shadow(0 0 10px rgba(56,198,58,0.4)) drop-shadow(0 0 20px rgba(18,10,143,0.5))`,
            }}
          >
            <svg width="52" height="52" viewBox="0 0 96 96" fill="none">
              <circle cx="48" cy="48" r="48" fill={C1} />
              <rect x="30" y="16" width="36" height="56" rx="8" fill="white" />
              <path
                d="M58 16C62.4183 16 66 19.5817 66 24V66.667H55.333V72H42C39.7909 72 38 73.7909 38 76C38 78.2091 39.7909 80 42 80H38C33.5817 80 30 76.4183 30 72V24C30 19.5817 33.5817 16 38 16H58Z"
                fill="white"
              />
              <circle
                cx="48"
                cy="44"
                r="14"
                fill={C2}
                style={{
                  transformOrigin: '48px 44px',
                  animation: 'ld-circle-scale 1.8s ease-in-out infinite',
                }}
              />
              <path
                d="M42 44L46 48L54 40"
                stroke="white"
                strokeWidth="4"
                strokeLinecap="round"
                strokeLinejoin="round"
                style={{
                  strokeDasharray: 30,
                  strokeDashoffset: 30,
                  animation: 'ld-check-draw 1.8s ease-in-out infinite',
                }}
              />
            </svg>
          </div>
        </div>

        {/* Progress bar */}
        <div
          style={{
            width: 90,
            height: 2,
            background: 'rgba(18,10,143,0.12)',
            borderRadius: 99,
            overflow: 'hidden',
          }}
        >
          <div
            style={{
              height: '100%',
              background: `linear-gradient(90deg, ${C1}, ${C2}, ${C3}, ${C4})`,
              borderRadius: 99,
              animation: 'ld-progress 1.2s cubic-bezier(0.4,0,0.2,1) infinite',
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default Loading;
